import type { RootOptions } from 'react-dom/client';
import { type BoundarySource, reportBoundaryError } from './reportBoundaryError';

type ReactErrorHandler = NonNullable<RootOptions['onCaughtError']>;

function createHandler(source: BoundarySource): ReactErrorHandler {
  return (error, errorInfo) => {
    reportBoundaryError(error, source, errorInfo.componentStack ?? undefined);
  };
}

export const errorHandlers: Pick<RootOptions, 'onCaughtError' | 'onUncaughtError' | 'onRecoverableError'> = {
  onCaughtError: createHandler('react-caught'),
  onUncaughtError: createHandler('react-uncaught'),
  onRecoverableError: createHandler('react-recoverable'),
};
